/* Rectangle Triangle — lightweight localStorage wishlist (rt-wishlist:v2) */
(function () {
  if (window.rtWishlist) { return; }
  var KEY = 'rt_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('rt:wishlist:change', { detail: { count: list.length } }));
  }
  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }
  function add(item) {
    if (!item || !item.handle) return;
    var list = read();
    if (!list.some(function (i) { return i.handle === item.handle; })) {
      list.push(item);
      write(list);
    }
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.handle !== handle; }));
  }
  /* rt-wishlist:v2 — header count bubble */
  function badge() {
    var n = read().length;
    var t = n > 99 ? '99+' : String(n);
    Array.prototype.forEach.call(document.querySelectorAll('.rt-wishlist-bubble'), function (b) {
      var span = b.querySelector('.rt-wishlist-count');
      var val = n > 0 ? t : '';
      if (span && span.textContent !== val) { span.textContent = val; }
      if (b.hidden !== (n === 0)) { b.hidden = (n === 0); }
    });
  }
  function sync(root) {
    var scope = root || document;
    var items = read();
    var handles = {};
    items.forEach(function (i) { handles[i.handle] = true; });
    Array.prototype.forEach.call(scope.querySelectorAll('.rt-wishlist-toggle'), function (btn) {
      var pressed = handles[btn.getAttribute('data-product-handle')] ? 'true' : 'false';
      if (btn.getAttribute('aria-pressed') !== pressed) { btn.setAttribute('aria-pressed', pressed); }
    });
    badge();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.rt-wishlist-toggle');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    if (has(handle)) {
      remove(handle);
    } else {
      add({
        handle: handle,
        id: btn.getAttribute('data-product-id') || '',
        title: btn.getAttribute('data-product-title') || '',
        url: btn.getAttribute('data-product-url') || ('/products/' + handle),
        image: btn.getAttribute('data-product-image') || '',
        added: Date.now()
      });
    }
    sync();
  }, true);

  window.rtWishlist = { read: read, add: add, remove: remove, has: has, sync: sync };

  if (document.readyState !== 'loading') { sync(); }
  else { document.addEventListener('DOMContentLoaded', function () { sync(); }); }
  document.addEventListener('shopify:section:load', function () { sync(); });

  /* rt-wishlist:v2 — re-sync hearts after AJAX re-renders (facets filter/sort, search, pagination) */
  var moTimer = null;
  var mo = new MutationObserver(function () {
    clearTimeout(moTimer);
    moTimer = setTimeout(function () { sync(); }, 80);
  });
  function observe() {
    if (document.body) { mo.observe(document.body, { childList: true, subtree: true }); }
  }
  if (document.readyState !== 'loading') { observe(); }
  else { document.addEventListener('DOMContentLoaded', observe); }
})();